import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import { selectLoggedAs } from "Selectors";
import { slugify } from "Utils";
import { TTP_LOGO_URL } from "Config";
import Communities from "./Communities";
import RightSide from "./RightSide";
import SubMenuContainer from "./SubMenu/SubMenuContainer";

import _ from "i18n";

import moment from "moment";
import "moment/locale/fr";
import "moment/locale/nl";
import "moment/locale/en-gb";

export class Menu extends Component {
  toggleSetting(e) {
    const menuLogo = document.getElementsByClassName("menu__logo").item(0)
      .classList;
    //const optionBtn = document.getElementsByClassName("toggleSetting").item(0).classList;
    const options = document.getElementsByClassName("setting-options").item(0)
      .classList;

    if (menuLogo.contains("display-settings")) {
      menuLogo.remove("display-settings");
      options.remove("show");
    } else {
      menuLogo.add("display-settings");
      options.add("show");
    }
  }

  render() {
    const { loggedAs, lng, navCommunity } = this.props;

    moment.locale(lng === "en" ? "en-gb" : lng);

    return (
      <header id="mainMenu">
        <div className="top-bar" id="animated-menu">
          <span className="menu__logo" data-toggle="offCanvas">
            {loggedAs === "GUEST" || !navCommunity ? null : (
              <div>
                <span
                  className="icon-options-vertical toggleSetting"
                  onClick={this.toggleSetting.bind(this)}
                />
                <ul className="setting-options">
                  <li>
                    <Link
                      to={`/community/${navCommunity.url ||
                        slugify(navCommunity.name)}/${
                        navCommunity.id
                      }/settings`}
                    >
                      {_("Settings")}
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={`/community/${navCommunity.url ||
                        slugify(navCommunity.name)}/${
                        navCommunity.id
                      }/categories`}
                    >
                      {_("Categories manager")}
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={`/community/${navCommunity.url ||
                        slugify(navCommunity.name)}/${navCommunity.id}/archive`}
                    >
                      {_("Archive")}
                    </Link>
                  </li>
                </ul>
              </div>
            )}
            <img src={TTP_LOGO_URL} alt="logo" />
            <h2>{_("Media")}</h2>
          </span>
          {loggedAs !== "GUEST" && loggedAs !== "EMPTY" ? (
            <nav className="top-bar-left">
              <ul className="menu">
                <Communities />
              </ul>
            </nav>
          ) : null}
          {loggedAs ? <RightSide /> : null}
        </div>
        <SubMenuContainer />
      </header>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  loggedAs: selectLoggedAs(state),
  currentNavPage: state.params.currentNavPage,
  lng: state.params.lng,
  navCommunity: state.auth.navCommunity
});

export default connect(mapStateToProps)(Menu);



// WEBPACK FOOTER //
// ./src/components/Menu/Menu.js